import cn from 'classnames'
import { getOnlyDigitalString } from 'legacy/lut/helpers/string/getOnlyDigitalString'
import { memo, useCallback, useMemo } from 'react'

import { Input } from 'core-components/library/inputs'
import { Tooltip } from 'core-components/library/tooltip'
import { ValidateInput } from 'core-components/library/validation'

import { MAX_PHONE_NUMBER_LENGTH } from '../../configs'

import { getPhoneNumberWithMask } from './helpers/getPhoneNumberWithMask'
import { isPropsEqual } from './helpers/isPropsEqual'
import { IPhoneNumberInputProps } from './models'

import styles from './PhoneNumberInput.module.scss'

export const PhoneNumberInput = memo<IPhoneNumberInputProps>(
  ({ classes, checkFn, label = '', isDisabled, errorMessage, value = '', onBlur, onChange }) => {
    const inputColor = errorMessage ? 'danger' : 'normal'
    const phoneNumberWithMask = useMemo(() => getPhoneNumberWithMask(value), [value])

    const handlePhoneNumberChange = useCallback(
      (value: string) => {
        const rawPhoneNumber = getOnlyDigitalString(value)
        if (rawPhoneNumber.length <= MAX_PHONE_NUMBER_LENGTH) {
          onChange(rawPhoneNumber)
        }
      },
      [onChange]
    )

    const renderTipContent = useCallback(() => <>{errorMessage}</>, [errorMessage])

    if (checkFn) {
      return (
        <ValidateInput
          checkFn={checkFn}
          disabled={isDisabled}
          type="tel"
          classes={{
            ...classes,
            validatorClasses: {
              ...classes?.validatorClasses,
              root: cn(classes?.validatorClasses?.root, styles.phoneNumberWrapper),
            },
          }}
          label={label}
          value={getPhoneNumberWithMask(value)}
          onChange={handlePhoneNumberChange}
        />
      )
    }

    return (
      <Tooltip
        className={styles.phoneNumberWrapper}
        disabled={!errorMessage}
        tipContent={renderTipContent}
      >
        <Input
          classes={classes?.inputClasses}
          disabled={isDisabled}
          type="tel"
          label={label}
          value={phoneNumberWithMask}
          onChange={handlePhoneNumberChange}
          wrapper={inputColor}
          onBlur={onBlur}
        />
      </Tooltip>
    )
  },
  isPropsEqual
)
